import React, { useState } from "react";
import { StarIcon, XMarkIcon } from "@heroicons/react/24/solid";

const FAVORITES_KEY = "favoriteCities";

const getFavorites = () => {
  try {
    return JSON.parse(localStorage.getItem(FAVORITES_KEY)) || [];
  } catch {
    return [];
  }
};

const FavoriteCitiesFloating = ({ onCitySelect }) => {
  const [open, setOpen] = useState(false);
  const [favorites, setFavorites] = useState(getFavorites());

  // Listen for changes in localStorage (in case favorites are updated elsewhere)
  React.useEffect(() => {
    const handler = () => setFavorites(getFavorites());
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  return (
    <>
      {/* Floating Button */}
      <button
        className="fixed z-50 bottom-4 right-4 sm:bottom-6 sm:right-6 bg-yellow-400 hover:bg-yellow-500 text-yellow-900 rounded-full shadow-lg p-3 flex items-center justify-center focus:outline-none"
        onClick={() => setOpen(true)}
        aria-label="Show favorite cities"
      >
        <StarIcon className="h-7 w-7" />
      </button>
      {/* Drawer/Modal */}
      {open && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black bg-opacity-30" onClick={() => setOpen(false)}>
          <div
            className="w-full sm:w-96 bg-white rounded-t-2xl sm:rounded-2xl shadow-lg p-6 max-h-[60vh] overflow-y-auto"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-bold text-yellow-700 flex items-center gap-2">
                <StarIcon className="h-6 w-6 text-yellow-500" /> Favorites
              </h2>
              <button onClick={() => setOpen(false)} aria-label="Close" className="text-gray-400 hover:text-gray-600">
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
            {favorites.length === 0 ? (
              <div className="text-gray-500 text-center py-8">No favorite cities yet.</div>
            ) : (
              <div className="flex flex-wrap gap-2 justify-center">
                {favorites.map((city, idx) => (
                  <button
                    key={city.name + idx}
                    className="px-3 py-2 bg-green-100 text-green-800 rounded text-sm hover:bg-green-200 transition"
                    onClick={() => {
                      onCitySelect(city);
                      setOpen(false);
                    }}
                  >
                    {city.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FavoriteCitiesFloating;
